/**
 * NotFoundPage — the router's catch-all: no such page.
 *
 * Permission misses no longer land here; the router sends every path in
 * `userProfile.restrictedRoutes` to AccessDeniedPage instead. So this now
 * means what it says — a bad or stale URL.
 *
 * Shares page-route-message.module.css with AccessDeniedPage.
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Card } from '../design-system';
import styles from './page-route-message.module.css';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={styles.page}>
      <Card padding="lg" className={styles.panel}>
        <div className={styles.iconBox} aria-hidden="true">
          <SearchOffIcon fontSize="large" />
        </div>
        <h1 className={styles.title}>Page not found</h1>
        <p className={styles.message}>
          We couldn&apos;t find that page. It may have been moved or renamed, or
          the link may be out of date.
        </p>
        <p className={styles.path}>{location.pathname}</p>
        <button className={styles.action} type="button" onClick={() => navigate('/')}>
          Go to Dashboard
        </button>
      </Card>
    </div>
  );
}
